(function () {
  if (window.tpiEnquiryClickBound) {
    return;
  }
  window.tpiEnquiryClickBound = true;
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-tpi-open-enquiry]');
    if (!btn) {
      return;
    }
    e.preventDefault();
    const id = btn.getAttribute('data-tpi-open-enquiry');
    const el = id ? document.getElementById(id) : null;
    if (el && typeof el.showDialog === 'function') {
      el.showDialog();
    }
  });
})();
